// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var PropertiesService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertiesService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Create a new property
     *
     * @since 1.0.0
     *
     * @param property Property data
     * @returns Observable<any>
     */
    PropertiesService.prototype.create = function (property) {
        return this.apiService.apiCall('POST', 'properties', property);
    };
    /**
     * Add a contact to property phonebook
     *
     * @since 1.0.0
     */
    PropertiesService.prototype.createPhonebookContact = function (propertyId, phonebookContact) {
        return this.apiService.apiCall('POST', "properties/" + propertyId + "/phonebook", phonebookContact);
    };
    /**
     * Get all properties list of master
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PropertiesService.prototype.getPropertiesMaster = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'properties/master-all', params);
    };
    /**
     * Get users list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PropertiesService.prototype.getList = function (start, limit, sort, sortVersus, search, active, nfcSubscriptionActive) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus, active: active, nfcSubscriptionActive: nfcSubscriptionActive };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'properties', params);
    };
    /**
     * Get users list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PropertiesService.prototype.getTagNfcList = function (start, limit, sort, sortVersus, search, active) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus, active: active };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "properties/tag-nfcs", params);
    };
    /**
     * Get creators list
     */
    PropertiesService.prototype.getTaggerUsers = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "properties/tagger-users", params);
    };
    /**
     * Get users list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PropertiesService.prototype.getSuspendedList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'properties/suspended', params);
    };
    /**
     * Get phonebook list for given query params
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results numbers
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PropertiesService.prototype.getPhonebookList = function (propertyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "properties/" + propertyId + "/phonebook", params);
    };
    //   /**
    //  * Get a visit of video by token
    //  *
    //  * @since 1.0.0
    //  *
    //  * @param propertyId Property Id
    //  * @param params User data
    //  * @returns Observable<any>
    //  */
    // getVideoVisitByToken(propertyId: string, token: string): Observable<any> {
    //   return this.apiService.apiCall('GET', `properties/${propertyId}/video-token/${token}`);
    // }
    // /**
    //  * Create a visit of video
    //  *
    //  * @since 1.0.0
    //  *
    //  * @param propertyId Property Id
    //  * @param params User data
    //  * @returns Observable<any>
    //  */
    // setVideoVisit(propertyId: string, params: any): Observable<any> {
    //   return this.apiService.apiCall('POST', `properties/${propertyId}/video`, params);
    // }
    /**
     * Get users list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PropertiesService.prototype.getInStructureList = function (topicKey, start, limit, sort, sortVersus, search) {
        var params = { topicKey: topicKey, start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'properties/in-structure', params);
    };
    /**
     * Get an exportation file of all properties
     *
     * @since 1.0.0
     */
    PropertiesService.prototype.getExportInStructureList = function (topicKey) {
        var _this = this;
        return this.apiService.apiCall('GET', 'properties/export-in-structure', { topicKey: topicKey }, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all properties
     *
     * @since 1.0.0
     */
    PropertiesService.prototype.getExport = function (companyId) {
        var _this = this;
        return this.apiService.apiCall('GET', 'properties/export', { companyId: companyId }, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all properties
     *
     * @since 1.0.0
     */
    PropertiesService.prototype.getTagNfcExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', "properties/tag-nfcs-export", {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all properties
     *
     * @since 1.0.0
     */
    PropertiesService.prototype.getExportSuspended = function (companyId) {
        var _this = this;
        return this.apiService.apiCall('GET', 'properties/export-suspended', { companyId: companyId }, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all properties
     *
     * @since 1.0.0
     */
    PropertiesService.prototype.getDocExport = function (target, propertyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "properties/" + propertyId + "/export/" + target, {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get RAS docs of property
     *
     * @since 1.0.0
     */
    PropertiesService.prototype.getRasDocs = function (propertyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "properties/" + propertyId + "/ras-docs").pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Export the files of all condominium documents in zip format
     *
     * @since 1.0.0
     */
    PropertiesService.prototype.getFileExport = function (propertyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "properties/" + propertyId + "/export-file").pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get given propertyId data from back-end
     *
     * @since 1.0.0
     *
     * @param propertyId ID of the property to get
     */
    PropertiesService.prototype.getByOldId = function (propertyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "properties/by-old-id/" + propertyId).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get given propertyId data from back-end
     *
     * @since 1.0.0
     *
     * @param propertyId ID of the property to get
     */
    PropertiesService.prototype.getView = function (propertyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "properties/" + propertyId + "/view").pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get given propertyId data from back-end
     *
     * @since 1.0.0
     *
     * @param propertyId ID of the property to get
     */
    PropertiesService.prototype.get = function (propertyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "properties/" + propertyId).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get property's structure
     *
     * @since 1.0.0
     *
     * @param propertyId ID of the property
     */
    PropertiesService.prototype.getStructure = function (endpoint) {
        return this.apiService.apiCall('GET', endpoint);
    };
    /**
     * Update property with given propertyId with given property data
     *
     * @since 1.0.0
     *
     * @param propertyId ID of property to update
     * @param data New property's data
     */
    PropertiesService.prototype.update = function (propertyId, data) {
        return this.apiService.apiCall('PUT', "properties/" + propertyId, data);
    };
    /**
     * Activate property
     *
     * @since 1.0.0
     *
     * @param propertyId ID of the property
     */
    PropertiesService.prototype.activate = function (propertyId) {
        return this.apiService.apiCall('POST', "properties/" + propertyId + "/activate");
    };
    /**
     * Update given phonebookContactId
     *
     * @since 1.0.0
     */
    PropertiesService.prototype.updatePhonebookContact = function (propertyId, phonebookContactId, data) {
        var _this = this;
        return this.apiService.apiCall('PUT', "properties/" + propertyId + "/phonebook/" + phonebookContactId, data).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update property's nfcDetails
     *
     * @since 1.0.0
     */
    PropertiesService.prototype.updateNfcDetails = function (propertyId, data) {
        var _this = this;
        return this.apiService.apiCall('PUT', "properties/" + propertyId + "/nfc", data).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Deactivate property
     *
     * @since 1.0.0
     *
     * @param propertyId ID of the property
     */
    PropertiesService.prototype.delete = function (propertyId) {
        return this.apiService.apiCall('DELETE', "properties/" + propertyId);
    };
    /**
     * Delete permanently a property's phonebook
     *
     * @since 1.0.0
     */
    PropertiesService.prototype.deletePhonebookContact = function (propertyId, phonebookContactId) {
        return this.apiService.apiCall('DELETE', "properties/" + propertyId + "/phonebook/" + phonebookContactId);
    };
    /**
     * Get Subscriptions Revenue
     *
     * @since 1.0.0
     *
     */
    PropertiesService.prototype.getSubscriptionsRevenue = function () {
        return this.apiService.apiCall('GET', 'properties/subscriptions-revenue');
    };
    /**
     * Toggle BiPy property with given propertyId
     *
     * @since 1.0.0
     *
     * @param propertyId ID of property to update
     */
    PropertiesService.prototype.toggleBipy = function (propertyId) {
        return this.apiService.apiCall('PATCH', "properties/" + propertyId + "/toggleBipy");
    };
    /**
     * Assigne Tagger user
     */
    PropertiesService.prototype.assignTagger = function (propertyId, userId) {
        return this.apiService.apiCall('PATCH', "properties/" + propertyId + "/assignTagger/" + userId);
    };
    /**
     * Assigne Taggers user
     */
    PropertiesService.prototype.assignTaggers = function (userId, data) {
        return this.apiService.apiCall('PATCH', "properties/assignTaggers/" + userId, data);
    };
    /**
     * Toggle BiPy property with given propertyId
     *
     * @since 1.0.0
     *
     * @param propertyId ID of property to update
     */
    PropertiesService.prototype.updateFields = function (propertyId, data) {
        return this.apiService.apiCall('PATCH', "properties/" + propertyId, data);
    };
    /**
     * Get all properties of company
     *
     * @since 1.0.0
     *
     * @param companyId ID company
     */
    PropertiesService.prototype.getCompanyProperties = function (companyId) {
        return this.apiService.apiCall('GET', "properties/company/" + companyId);
    };
    PropertiesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PropertiesService_Factory() { return new PropertiesService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: PropertiesService, providedIn: "root" });
    return PropertiesService;
}());
export { PropertiesService };
